import { render, staticRenderFns } from "./WellElecControllLastRecordList.vue?vue&type=template&id=f432d30c"
import script from "./WellElecControllLastRecordList.vue?vue&type=script&lang=js"
export * from "./WellElecControllLastRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports